export default __webpack_public_path__ + "static/media/12.20aa0b8e.jpeg";